"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Domain = void 0;
const ErrorDescriptor_1 = require("./ErrorDescriptor");
const getCodeFromError_1 = require("./getCodeFromError");
const errors_1 = require("./errors");
class Domain {
    constructor() {
        this.descriptors = new Map();
        this.isLocked = false;
    }
    isErrorFromDomain(error) {
        const code = (0, getCodeFromError_1.getCodeFromError)(error);
        if (code) {
            return !!this.getErrorDescriptorForCode(code);
        }
    }
    /**
     * Locks entire domain. That means no further error descriptors could be added to it
     */
    lock() {
        this.isLocked = true;
        return this;
    }
    /**
     * Asserts that given code is not registered within domain
     */
    assertErrorCodeNotRegistered(errorDescriptorOrCode) {
        const code = ErrorDescriptor_1.ErrorDescriptor.isType(errorDescriptorOrCode) ? errorDescriptorOrCode.code : errorDescriptorOrCode;
        if (this.getErrorDescriptorForCode(code)) {
            throw errors_1.ERRORS.CODE_ALREADY_TAKEN(code);
        }
    }
    /**
     * Adds error descriptor to damain.
     *
     * Fails if domain already contains
     */
    addErrorDescriptor(errorDescriptor) {
        this.assertNotLocked();
        const code = errorDescriptor.code;
        this.assertErrorCodeNotRegistered(errorDescriptor);
        this.descriptors.set(code, errorDescriptor);
        return this;
    }
    assertNotLocked() {
        if (this.isLocked) {
            throw new Error('Domain is locked and no other error descriptors can be added');
        }
    }
    /**
     * Adds object with error descriptors to domain
     */
    addErrorsDescriptorsMap(errors) {
        for (const [key, descriptor] of Object.entries(errors)) {
            if (!ErrorDescriptor_1.ErrorDescriptor.isType(descriptor)) {
                throw errors_1.ERRORS.INVALID_ERROR_DESCRIPTOR_UNDER_KEY(key);
            }
            this.addErrorDescriptor(descriptor);
        }
        return errors;
    }
    getErrorDescriptorForCode(code) {
        return this.descriptors.get(code);
    }
    *[Symbol.iterator]() {
        yield* this.descriptors.values();
    }
}
exports.Domain = Domain;
